import { render, staticRenderFns } from "./ProfileFunctionCard.vue?vue&type=template&id=a35ba12e"
import script from "./ProfileFunctionCard.vue?vue&type=script&lang=js"
export * from "./ProfileFunctionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports